// Story 70.1 (RC-148, RC-144) — o horário padrão da clínica que nunca salvou um. Uma definição
// só: a tela Clínica mostra este e a agenda sombreia este. Chaves = getDay() (0 = domingo).
const DEFAULT_OPEN = '08:00';
const DEFAULT_CLOSE = '18:00';
const DEFAULT_OPEN_DAYS = [1, 2, 3, 4, 5, 6];
/** Segunda a sábado, 08:00 às 18:00; domingo fechado. */
export const DEFAULT_BUSINESS_HOURS = Object.freeze(Object.fromEntries([0, 1, 2, 3, 4, 5, 6].map((day) => [
    String(day),
    Object.freeze({ open: DEFAULT_OPEN, close: DEFAULT_CLOSE, active: DEFAULT_OPEN_DAYS.includes(day) }),
])));
/** O mesmo padrão no formato do FullCalendar. */
export const DEFAULT_FC_BUSINESS_HOURS = Object.freeze({
    daysOfWeek: [...DEFAULT_OPEN_DAYS],
    startTime: DEFAULT_OPEN,
    endTime: DEFAULT_CLOSE,
});
/** Horário salvo → FullCalendar; sem horário salvo (ou nenhum dia aberto), o padrão. */
export function toFullCalendarBusinessHours(businessHours) {
    if (!businessHours || Object.keys(businessHours).length === 0)
        return DEFAULT_FC_BUSINESS_HOURS;
    const entries = Object.entries(businessHours)
        .filter((entry) => !!(entry[1]?.active && entry[1].open && entry[1].close))
        .map(([key, day]) => ({ daysOfWeek: [Number(key)], startTime: day.open, endTime: day.close }));
    return entries.length > 0 ? entries : DEFAULT_FC_BUSINESS_HOURS;
}
//# sourceMappingURL=business-hours.js.map